<div class="mapa-base-wrapper">
  <div #contenedor class="mapa-base-container"></div>
</div>
